module.exports = __webpack_public_path__ + "img/0Q3A3375_L_Black_MockedUp.a3342e55.jpg";